import { appConfig } from 'config/appConfig';
import { getTrackingServicesUser } from 'utils/user';
import { getHmacForField } from 'utils/crypto';
import { isExceptionPath } from 'utils/paths';
import { fullStoryExceptionPaths } from 'config/trackingServicesExceptionPaths';
import * as FullStory from '@fullstory/browser';

export const initFullStory = async (currentUser, pathname, isExternalAccess = false) => {
  if (isExceptionPath(pathname, fullStoryExceptionPaths)) return;

  const availableUser = getTrackingServicesUser(currentUser, pathname, isExternalAccess);
  if (!availableUser) return;

  if (!FullStory.isInitialized())
    FullStory.init({ orgId: appConfig.FULL_STORY_ID, devMode: appConfig.FULL_STORY_DEVMODE });
  if (FullStory.isInitialized()) {
    const uid = await getHmacForField(availableUser.uid);

    FullStory.identify(uid, {
      displayName: availableUser.name,
      email: availableUser.email,
    });
  }
};
